<template>
    <HeaderList></HeaderList>
    <div class="group relative pt-12 h-full bg-theme-gray">
        <GroupView></GroupView>
    </div>
</template>

<script>
import HeaderList from '@/components/HeaderList.vue';
import GroupView from '@/components/GroupView.vue';

export default {
    name: 'Group',
    components: {
        HeaderList,
        GroupView
    }
};
</script>